 (function (root) {
  'use strict';
  // Planning range only: native Buunto remains the final authority for availability,
  // selected method/time and delivery charges. This file does not open launch gates.
  // Component native rule: pickup Mon-Fri, 0-day lead with 11am SGT cutoff; delivery every day, 1-day lead.
  // The global Buunto DEFAULT starts tomorrow and must not be changed for this patch.
  const dayMs = 86400000;
  const singaporeDay = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Singapore', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
  });
  function singaporeClock() {
    const parts = Object.fromEntries(singaporeDay.formatToParts(new Date()).map(p => [p.type, p.value]));
    return { day: Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)), beforePickupCutoff: Number(parts.hour) < 11 };
  }
  function parseDay(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return NaN;
    const stamp = Date.parse(value + 'T00:00:00Z');
    return Number.isFinite(stamp) && new Date(stamp).toISOString().slice(0, 10) === value ? stamp : NaN;
  }
  const methods = ['Store pickup', 'Local delivery'];
  function allowedMethodsForDate(value) {
    const stamp = parseDay(value), now = singaporeClock(), daysAhead = (stamp - now.day) / dayMs;
    if (!Number.isInteger(daysAhead) || daysAhead < 0 || daysAhead > 90) return [];
    const weekday = new Date(stamp).getUTCDay(), allowed = [];
    if (weekday >= 1 && weekday <= 5 && (daysAhead > 0 || now.beforePickupCutoff)) allowed.push('Store pickup');
    if (daysAhead >= 1) allowed.push('Local delivery');
    return allowed;
  }
  function isValidDate(value) {
    return allowedMethodsForDate(value).length > 0; // Union for cart integrity, not the active planner filter.
  }
  function availableDates(method) {
    if (method !== undefined && !methods.includes(method)) return [];
    const now = singaporeClock();
    return Array.from({ length: 91 }, (_, index) => new Date(now.day + index * dayMs).toISOString().slice(0, 10))
      .filter(value => method === undefined ? isValidDate(value) : allowedMethodsForDate(value).includes(method));
  }
  function noticeForMethod(method, lang = 'en') {
    if (method === 'Store pickup') return lang === 'zh'
      ? '自取仅限周一至周五。新加坡时间上午11点前可选当天；11点起请选择下一个工作日。请在购物车选择自取并确认相同日期及可选时段。'
      : 'Pickup: Monday–Friday only. Same-day pickup before 11am Singapore time; from 11am choose the next weekday. Select pickup and confirm the matching date and an available time in the cart.';
    return lang === 'zh'
      ? '本地配送：每天可选，最早从明天开始，无当天配送。请在购物车选择本地配送并确认相同日期及可选时段。'
      : 'Local delivery: every day, starting tomorrow. No same-day delivery. Select local delivery and confirm the matching date and an available time in the cart.';
  }
  root.MAFE_CBD_FULFILMENT = Object.freeze({
    approved: true,
    nativeBuunto: true,
    timeZone: 'Asia/Singapore',
    availableDates,
    isValidDate,
    allowedMethodsForDate,
    noticeForMethod,
    customerNotice: 'Pickup Monday-Friday only, same-day before 11am Singapore time. Local delivery every day from tomorrow. Plan up to 90 days ahead, one date per checkout. Native cart availability is final.',
    customerNoticeZh: '自取仅限周一至周五，新加坡时间上午11点前可选当天；本地配送每天可选，最早从明天开始。可安排未来90天，每次结账仅限一个日期。实际可选安排以购物车为准。'
  });
})(typeof window === 'undefined' ? globalThis : window);
